module.exports = __webpack_public_path__ + "img/ascend_gold34.a61b0e83.png";